import styled from 'styled-components'

export const AddPeopleContainer = styled.div`
  max-height: 565px;
  overflow-y: scroll;

  .invitees-row {
    &:last-child {
      border-bottom: 1px solid #dee2e6;
    }

    td {
      border-top: 1px solid #dee2e6;
    }
  }
`
